var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasLocations && _vm.locationsInFrame.length < 100)?_c('MglGeojsonLayer',{attrs:{"source":_vm.geoJsonSource,"layerId":_vm.geoJsonlayer.id,"layer":_vm.geoJsonlayer,"source-id":"maps"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }